import { createBrowserClient } from '@supabase/ssr';

// Esta app é Vite: por omissão só variáveis com prefixo VITE_ são expostas ao
// browser, por isso as VITE_* são as que realmente funcionam aqui. As
// NEXT_PUBLIC_* ficam como fallback para a migração Next.js arquivada.
const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Variáveis VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY são obrigatórias — defina-as em .env.local.'
  );
}

// Domínio do cookie só é fixado em produção (tamoaki.co.ao) — é o que permite
// à futura app Next.js (mesmo domínio, projeto Vercel diferente, ver plano de
// migração SSR) ler a mesma sessão sem forçar novo login. Em dev/preview
// (localhost, *.vercel.app) deixamos o browser inferir o host atual, senão o
// cookie nunca fica visível ali.
const isProdDomain =
  typeof window !== 'undefined' && window.location.hostname.endsWith('tamoaki.co.ao');

export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey, {
  cookieOptions: {
    domain: isProdDomain ? 'tamoaki.co.ao' : undefined,
    path: '/',
    sameSite: 'lax',
    secure: isProdDomain,
  },
  global: {
    headers: {
      // Evita 406 Not Acceptable no PostgREST: força JSON em todas as respostas
      Accept: 'application/json'
    }
  }
})

// Migração one-time: sessões antigas viviam em localStorage sob a chave
// 'tamoaki_clientes_auth' (client-only, inacessível a partir de Server
// Components/middleware). Promovemos o token antigo para o novo storage
// baseado em cookies, para não forçar logout de toda a base de utilizadores
// ativa na troca. Ver Fase 0.1 do plano de migração SSR.
const LEGACY_STORAGE_KEY = 'tamoaki_clientes_auth';
if (typeof window !== 'undefined') {
  try {
    const legacyRaw = window.localStorage.getItem(LEGACY_STORAGE_KEY);
    if (legacyRaw) {
      const legacy = JSON.parse(legacyRaw);
      const accessToken = legacy?.access_token;
      const refreshToken = legacy?.refresh_token;
      if (accessToken && refreshToken) {
        supabase.auth
          .setSession({ access_token: accessToken, refresh_token: refreshToken })
          .finally(() => window.localStorage.removeItem(LEGACY_STORAGE_KEY));
      } else {
        window.localStorage.removeItem(LEGACY_STORAGE_KEY);
      }
    }
  } catch (err) {
    console.warn('⚠️ Falha ao migrar sessão antiga de localStorage para cookies:', err);
  }
}

// Nota: clientes administradores com service role devem ser usados APENAS em scripts Node/servidor.
